/* eslint-disable react-hooks/rules-of-hooks */
import { useMe } from "~/services";
import ConflictingSettings from "~/views/Administration/Settings/ConflictingSettings";
import ConstitutionDaysSettings from "~/views/Administration/Settings/ConstitutionDaysSettings";
import DuplicitySettings from "~/views/Administration/Settings/DuplicitySettings";
import GroupSettings from "~/views/Administration/Settings/GroupSettings";
import NotificationSettings from "~/views/Administration/Settings/NotificationSettings";
import PartnerSettings from "~/views/Administration/Settings/PartnerSettings";
import ProcessAutomationSettings from "~/views/Administration/Settings/ProcessAutomationSettings";
import ProcessPolaritySettings from "~/views/Administration/Settings/ProcessPolaritySettings";
import RiskSettings from "~/views/Administration/Settings/RiskSettings";
import TagSettings from "~/views/Administration/Settings/TagSettings";
import UsageSettings from "~/views/Administration/Settings/UsageSettings";

const sections = (t) => {
  const { user } = useMe();
  return [
    {
      show: user?.hierarquia?.length > 1,
      label: t("group.label"),
      content: GroupSettings,
    },   
    {
      show: user?.usuario?.perfil?.id >= 4,
      label: t("duplicityOpen.label"),
      content: DuplicitySettings,
    },
    {
      show: user?.usuario?.perfil?.id >= 3,
      label: t("partner.label"),
      content: PartnerSettings,
    },
    {
      show: user?.usuario?.perfil?.id >= 3,
      label: t("process_automation.label"),
      content: ProcessAutomationSettings,
    },
    {
      show: user?.usuario?.perfil?.id >= 1,
      label: t("notification.label"),
      content: NotificationSettings,
    },
    {
      show: user?.usuario?.perfil?.id >= 4,
      label: t("risk.label"),
      content: RiskSettings,
    },
    {
      show: user?.usuario?.perfil?.id >= 4,
      label: t("process_polarity.label"),
      content: ProcessPolaritySettings,
    },
    {
      show: user?.usuario?.perfil?.id >= 3,
      label: t("conflict.label"),
      content: ConflictingSettings,
    },
    {
      show: user?.usuario?.perfil?.id === 4,
      label: t("usage.label"),
      content: UsageSettings,
    },
    {
      show: user?.usuario?.perfil?.id >= 4,
      label: t("tag.label"),
      content: TagSettings,
    },
    {
      show: user?.usuario?.perfil?.id >= 3,
      label: t("constitution_days.label"),
      content: ConstitutionDaysSettings,
    },
 
  ];
};

export default sections;
